import React, { Component } from "react";
import {
  Col,
  Form,
  Icon,
  Input,
  message,
  Radio,
  Row,
  Select,
  Switch,
  TreeSelect,
  Upload,
} from "antd";
import { downloadImg, uploadImg } from "@/utils/constant";
import $$ from "cmn-utils";
import intl from "react-intl-universal";
import PasswordInput from "@/components/Password/PasswordInput";
import Level from "@/components/Password/Level";
import PasswordLevel from "@/utils/passwordLevel";
import { getStrLength, hasChinese } from "@/utils/tool";
import { connect } from "dva";
import http from "@/http";
import styles from "./info.module.less";
import { DarkModal } from "@/components/Modal";
import darkControl from "@/components/Modal/darkControl.module.less";

const HttpUser = http.tokiot.sys.user;
const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;

const uploadFileType = "image/*";
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 7 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};
const pushItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 15 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 9 },
  },
};

const uploadButton = (
  <div>
    <Icon antd type="plus" />
    <div className="ant-upload-text" style={{ color: "#fff" }}>
      Upload
    </div>
  </div>
);

class UserInfo extends Component {
  state = {
    imgUrl: null,
    roles: [],
    score: 0,
  };

  componentDidMount() {
    const { unitId } = this.props.detail;
    unitId && this.loadRoLeList({ unitId });
  }

  /**
   * 计算密码评分
   * @param {*} value
   * @param {*} callback
   */
  handleCheckPwd = (value, callback) => {
    const password = new PasswordLevel(value);
    const score = password.getScore();
    this.setState({ score });
    if (password.getLength() == 0 && this.isUpdata) callback();
    if (password.getLength() < 8) callback("至少要8个字符。");
    if (password.getNumberCount() == 0) callback("需至少包含一个数字。");
    if (password.getUpLetterCount() == 0 && password.getLowLetterCount() == 0)
      callback("需至少包含一个字母。");
    if (password.getSymbolCount() == 0) callback("需至少包含一个符号。");
    if (score < 60)
      callback("密码强度至少中级（60分），当前评分：" + score + "。");
    callback();
  };

  handleUpload(e, type) {
    const file = e.fileList[e.fileList.length - 1];
    if (file.status === "done") {
      const res = file.response;
      if (res.code === "OK") {
        this.setState({ imgUrl: res.body });
        return res.body;
      } else {
        message.error(res.message);
      }
    }
  }

  handleSubmit = () => {
    const { form, detail, onClose, onChange } = this.props;
    const { validateFieldsAndScroll } = form;
    validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (this.isUpdata) {
          if (!values.password) delete values.password;
          if (!values.passwordAga) delete values.passwordAga;
          values.id = detail.id;
          HttpUser.update(values).then((ret) => {
            if (ret) {
              onChange && onChange();
              onClose && onClose();
            } else {
              message.error(`修改失败`);
            }
          });
        } else {
          HttpUser.create(values).then((ret) => {
            if (ret) {
              onChange && onChange();
              onClose && onClose();
            } else {
              message.error(`创建失败`);
            }
          });
        }
      } else {
        return;
      }
    });
  };

  /**
   * 校验昵稱長度
   */
  handleRealName(realName, callback) {
    const length = getStrLength(realName);
    if (length >= 4 && length <= 20) {
      callback();
    } else {
      callback(intl.get("message.realName.longError"));
    }
  }

  /**
   * 校验用户名是否存在
   */
  handleExistUsername(username, callback) {
    if (hasChinese(username)) {
      callback(intl.get("message.userName.chinese"));
    }
    const length = getStrLength(username);
    const { detail } = this.props;
    if (length >= 4 && length <= 20) {
      if (this.isUpdata && detail.username === username) {
        callback();
      } else {
        this.onExistUsername(username, (ret) => {
          if (ret) {
            callback();
          } else {
            callback(intl.get("message.userName.exist"));
          }
        });
      }
    } else {
      callback(intl.get("message.userName.longError"));
    }
  }

  /**
   * 校验手机号是否存在
   */
  handleExistMobile(mobile, callback) {
    if (mobile.length === 11) {
      const { detail } = this.props;
      const reg = /^1[0-9][0-9]\d{8}$/;
      if (reg.test(mobile)) {
        if (this.isUpdata && detail.tel === mobile) {
          callback();
        } else {
          this.onExistMobile(mobile, (ret) => {
            if (ret) {
              callback();
            } else {
              callback(intl.get("message.phone.exist"));
            }
          });
        }
      } else {
        callback(intl.get("message.phone.formatError"));
      }
    } else {
      callback(intl.get("message.phone.longError"));
    }
  }

  /**
   * 校验用户名是否存在
   */
  onExistUsername(username, callback) {
    HttpUser.existUsername({ username }).then((ret) => {
      callback(ret);
    });
  }

  /**
   * 校验手机号是否存在
   */
  onExistMobile(mobile, callback) {
    HttpUser.existMobile({ mobile }).then((ret) => {
      callback(ret);
    });
  }

  /**
   * 校验邮箱是否存在
   */
  onExistEmail = (email, callback) => {
    HttpUser.existEmail({ email }).then((ret) => {
      callback(ret);
    });
  };

  /**
   * 校验邮箱是否存在
   */
  handleExistEmail(email, callback) {
    if (!(email && email.trim().length > 0)) {
      callback();
    } else {
      if (email.trim().length > 0) {
        const { detail } = this.props;
        const reg =
          /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (reg.test(email)) {
          if (this.isUpdata && detail.email === email) {
            callback();
          }
          this.onExistEmail(email, (ret) => {
            if (ret) {
              callback();
            } else {
              callback(intl.get("message.email.exist"));
            }
          });
        } else {
          callback(intl.get("message.email.formatError"));
        }
      } else {
        callback(intl.get("message.email.none"));
      }
    }
  }

  /**
   * 校验两次密码是否一致
   */
  handleCheckConfirmPwd(value, callback) {
    const { form } = this.props;
    const { getFieldValue } = form;
    const password = getFieldValue("password");
    if (password === value) {
      callback();
    } else {
      if (this.isUpdata && !password && !value) {
        callback();
      }
      callback(intl.get("message.password.different"));
    }
  }

  loadRoLeList = (data = {}) => {
    http.tokiot.sys.role.list(data).then((roles) => {
      if (roles) {
        this.setState({ roles });
      } else {
        this.setState({ roles: [] });
      }
    });
  };
  changUnit = (unitId) => {
    this.props.form.setFieldsValue({ roleId: null });
    this.loadRoLeList({ unitId });
  };
  /**
   * 开关发生改变
   */
  handleSwitchChange = (checked, type) => {
    const { form } = this.props;
    form.setFieldsValue({ [type]: checked });
  };

  get isUpdata() {
    const { detail } = this.props;
    return detail && detail.id && detail.id.length > 0;
  }

  render() {
    const { form, detail: proDetail, onClose, visible, unitList } = this.props;
    const { getFieldDecorator, getFieldValue } = form;
    const { imgUrl, score, roles } = this.state;
    let detail = proDetail ? proDetail : {};
    let userAuthority = ``;
    if (
      roles &&
      roles.length > 0 &&
      roles.findIndex((f1) => f1.id === detail.roleId) >= 0
    ) {
      userAuthority = detail.roleId;
    } else {
      userAuthority = detail.roleName;
    }
    return (
      <DarkModal
        className={darkControl.darkControl}
        title={this.isUpdata ? "用户详情" : "创建用户"}
        centered
        maskClosable={false}
        width={"11rem"}
        visible={visible}
        okText={this.isUpdata ? "修改" : "创建"}
        onOk={(_) => {
          this.handleSubmit();
        }}
        onCancel={(_) => {
          this.props.form.resetFields();
          onClose && onClose();
        }}
      >
        <div className={styles.mainDiv}>
          <Form
            hideRequiredMark={false}
            {...formItemLayout}
            style={{ maxHeight: "calc(100% - 1.2rem)", overflowY: "auto" }}
          >
            <Row>
              <Col span={12}>
                <FormItem label={intl.get("form.system.user.username")}>
                  {getFieldDecorator("username", {
                    initialValue: detail.username,
                    rules: [
                      {
                        required: true,
                        message: intl.get("form.system.user.username.please"),
                      },
                      { max: 20, message: "长度不能大于20" },
                      {
                        validator: (rule, value, callback) =>
                          this.handleExistUsername(value, callback),
                      },
                    ],
                  })(
                    <Input
                      disabled={this.isUpdata}
                      placeholder={intl.get("form.system.user.username.please")}
                    />
                  )}
                </FormItem>
                <FormItem label={intl.get("form.system.user.realName")}>
                  {getFieldDecorator("realName", {
                    initialValue: detail.realName,
                    rules: [
                      {
                        required: true,
                        message: intl.get("form.system.user.realName.please"),
                      },
                      { max: 20, message: "长度不能大于20" },
                      {
                        validator: (rule, value, callback) =>
                          this.handleRealName(value, callback),
                      },
                    ],
                  })(
                    <Input
                      placeholder={intl.get("form.system.user.realName")}
                    />
                  )}
                </FormItem>

                <FormItem label={"所属单位"}>
                  {getFieldDecorator("unitId", {
                    initialValue: detail.unitId,
                    rules: [
                      {
                        required: true,
                        message: intl.get("form.system.user.unti.please"),
                      },
                    ],
                  })(
                    <TreeSelect
                      disabled={this.isUpdata}
                      style={{ width: "100%" }}
                      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                      treeData={unitList}
                      treeNodeFilterProp="title"
                      showSearch
                      placeholder={intl.get("form.system.user.unti.please")}
                      onChange={this.changUnit}
                      treeDefaultExpandAll
                    />
                  )}
                </FormItem>
                <FormItem label={intl.get("form.system.user.password")}>
                  {getFieldDecorator("password", {
                    initialValue: detail.password,
                    rules: [
                      {
                        required: !this.isUpdata,
                        message: intl.get("form.system.user.password.please"),
                      },
                      { max: 20, message: "长度不能大于20" },
                      {
                        validator: (rule, value, callback) =>
                          this.handleCheckPwd(value, callback),
                      },
                    ],
                  })(
                    <PasswordInput
                      autoComplete={`new-password`}
                      placeholder={
                        this.isUpdata
                          ? intl.get("form.system.user.password.please.none")
                          : intl.get("form.system.user.password.please")
                      }
                    />
                  )}
                </FormItem>
                <FormItem label=" " colon={false}>
                  <Level score={score} />
                </FormItem>
                <FormItem label={intl.get("form.system.user.passwordAga")}>
                  {getFieldDecorator("passwordAga", {
                    initialValue: detail.password,
                    rules: [
                      {
                        required: !this.isUpdata,
                        message: intl.get("form.system.user.password.please"),
                      },
                      {
                        validator: (rule, value, callback) =>
                          this.handleCheckConfirmPwd(value, callback),
                      },
                    ],
                  })(
                    <PasswordInput
                      autoComplete={`new-password`}
                      placeholder={
                        this.isUpdata
                          ? intl.get("form.system.user.passwordAga.please.none")
                          : intl.get("form.system.user.passwordAga.please")
                      }
                    />
                  )}
                </FormItem>
                <FormItem
                  label={intl.get("form.system.user.pwdExpriredTimeType")}
                >
                  {getFieldDecorator("pwdExpriredTimeType", {
                    initialValue:
                      detail.pwdExpriredTimeType !== undefined
                        ? detail.pwdExpriredTimeType.toString()
                        : "0",
                    rules: [{ required: true }],
                  })(
                    <RadioGroup>
                      <Radio value="1">
                        {intl.get("form.system.user.pwdExpriredTimeType.1")}
                      </Radio>
                      <Radio value="0">
                        {intl.get("form.system.user.pwdExpriredTimeType.0")}
                      </Radio>
                    </RadioGroup>
                  )}
                </FormItem>
                <FormItem label={intl.get("form.system.user.tel")}>
                  {getFieldDecorator("tel", {
                    initialValue: detail.tel,
                    rules: [
                      {
                        required: true,
                        message: intl.get("form.system.user.tel.please"),
                      },
                      {
                        validator: (rule, value, callback) =>
                          this.handleExistMobile(value, callback),
                      },
                    ],
                  })(
                    <Input
                      placeholder={intl.get("form.system.user.tel.please")}
                    />
                  )}
                </FormItem>
                <FormItem label={intl.get("form.system.user.email")}>
                  {getFieldDecorator("email", {
                    initialValue: detail.email,
                    rules: [
                      {
                        validator: (rule, value, callback) =>
                          this.handleExistEmail(value, callback),
                      },
                    ],
                  })(
                    <Input
                      autoComplete={`new-password`}
                      placeholder={intl.get("form.system.user.email.please")}
                    />
                  )}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label={intl.get("form.system.user.role")}>
                  {getFieldDecorator("roleId", {
                    initialValue: userAuthority,
                    rules: [
                      {
                        required: true,
                        message: intl.get("form.system.user.role.please"),
                      },
                    ],
                  })(
                    <Select
                      disabled={!getFieldValue("unitId")}
                      placeholder={intl.get("form.system.user.role.please")}
                      style={{ width: "100%" }}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {roles.map((item) => {
                        return (
                          <Option key={item.code} value={item.id}>
                            {item.name}
                          </Option>
                        );
                      })}
                    </Select>
                  )}
                </FormItem>

                <FormItem label={"激活状态"}>
                  {getFieldDecorator("dataState", {
                    initialValue: detail.dataState
                      ? detail.dataState
                      : "Enable",
                    rule: [
                      {
                        require: true,
                        message: intl.get("form.system.user.dataState.please"),
                      },
                    ],
                  })(
                    <RadioGroup>
                      <Radio value="Enable">
                        {intl.get("form.system.user.dataState.enable")}
                      </Radio>
                      <Radio value="Disabled">
                        {intl.get("form.system.user.dataState.disabled")}
                      </Radio>
                    </RadioGroup>
                  )}
                </FormItem>
                <FormItem label={"头像"}>
                  {getFieldDecorator("avatar", {
                    initialValue: detail.avatar,
                    getValueFromEvent: (e) => this.handleUpload(e, "imgUrl"),
                    rule: [
                      {
                        // require: true,
                        message: intl.get("form.system.user.userIcon.please"),
                      },
                    ],
                  })(
                    <Upload
                      name="file"
                      data={{ type: "SYSTEM" }}
                      accept={uploadFileType}
                      action={uploadImg}
                      listType="picture-card"
                      headers={(() => $$.getStore("headers"))()}
                      showUploadList={false}
                      style={{ height: 102, width: 102 }}
                    >
                      {imgUrl || (detail && detail.avatar) ? (
                        <img
                          className={styles.image}
                          big={false}
                          alt="logo"
                          src={downloadImg + (imgUrl ? imgUrl : detail.avatar)}
                        />
                      ) : (
                        uploadButton
                      )}
                    </Upload>
                  )}
                  <span style={{ color: "#fff" }}>
                    {intl.get("form.system.user.userIcon")}
                  </span>
                </FormItem>
                <Row>
                  <Col span={11}>
                    <FormItem label={"APP推送"} {...pushItemLayout}>
                      {getFieldDecorator("pushApp", {
                        initialValue:
                          detail.pushApp !== undefined ? detail.pushApp : true,
                      })(
                        <Switch
                          checked={form.getFieldValue("pushApp")}
                          onChange={(checked) =>
                            this.handleSwitchChange(checked, "pushApp")
                          }
                        />
                      )}
                    </FormItem>
                  </Col>
                  <Col span={11}>
                    <FormItem label={"短信推送"} {...pushItemLayout}>
                      {getFieldDecorator("pushSms", {
                        initialValue:
                          detail.pushSms !== undefined ? detail.pushSms : false,
                      })(
                        <Switch
                          checked={form.getFieldValue("pushSms")}
                          onChange={(checked) =>
                            this.handleSwitchChange(checked, "pushSms")
                          }
                        />
                      )}
                    </FormItem>
                  </Col>
                  <Col span={11}>
                    <FormItem label={"网页推送"} {...pushItemLayout}>
                      {getFieldDecorator("pushWeb", {
                        initialValue:
                          detail.pushWeb !== undefined ? detail.pushWeb : true,
                      })(
                        <Switch
                          checked={form.getFieldValue("pushWeb")}
                          onChange={(checked) =>
                            this.handleSwitchChange(checked, "pushWeb")
                          }
                        />
                      )}
                    </FormItem>
                  </Col>
                  <Col span={11}>
                    <FormItem label={"语音推送"} {...pushItemLayout}>
                      {getFieldDecorator("pushTel", {
                        initialValue:
                          detail.pushTel !== undefined ? detail.pushTel : false,
                      })(
                        <Switch
                          checked={form.getFieldValue("pushTel")}
                          onChange={(checked) =>
                            this.handleSwitchChange(checked, "pushTel")
                          }
                        />
                      )}
                    </FormItem>
                  </Col>
                  <Col span={11}>
                    <FormItem label={"微信推送"} {...pushItemLayout}>
                      {getFieldDecorator("pushWechat", {
                        initialValue:
                          detail.pushWechat !== undefined
                            ? detail.pushWechat
                            : true,
                      })(
                        <Switch
                          checked={form.getFieldValue("pushWechat")}
                          onChange={(checked) =>
                            this.handleSwitchChange(checked, "pushWechat")
                          }
                        />
                      )}
                    </FormItem>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </DarkModal>
    );
  }
}

export default Form.create()(UserInfo);
